import { EncryptStorage } from "encrypt-storage";

const encryptStorage = new EncryptStorage("your-secret-key", {
    storageType: "sessionStorage",
    stateManagementUse: true,
});

export default encryptStorage;